import React from 'react'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {HasPermission} from '../../../global/functions'
import {useSelector} from 'react-redux'
import {StoreModel} from '../../../../app/redux/types'

export function MenuInner() {
  const {currentUser} = useSelector((state: StoreModel) => state.globalStates)

  return (
    <>
      <MenuInnerWithSub
        title='Business Settings'
        to='/business'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        {/* PAGES */}
        <MenuItem
          icon='/media/icons/duotune/finance/fin006.svg'
          to='/business/addbusiness'
          title='Add Business'
        />
        <MenuItem
          icon='/media/icons/duotune/general/gen022.svg'
          to='/business/mybusinesses'
          title='My Businesses'
        />
        <MenuItem
          icon='/media/icons/duotune/abstract/abs019.svg'
          to='/business/allbusinesses'
          title='All Businesses'
        />
      </MenuInnerWithSub>

      {currentUser && currentUser?.business_list.length > 0 && (
        <MenuInnerWithSub
          title='System Administration'
          to='/app'
          menuPlacement='bottom-start'
          menuTrigger='click'
        >
          {/* Departments */}
          {(HasPermission('department', 'create') || HasPermission('department', 'read')) && (
            <MenuInnerWithSub
              title='Departments'
              to='/departments'
              fontIcon='bi-building'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {HasPermission('department', 'create') && (
                <MenuItem to='/app/departments/add' title='Add New Department' hasBullet={true} />
              )}

              {HasPermission('department', 'read') && (
                <MenuItem to='/app/departments/all' title='View All Departments' hasBullet={true} />
              )}
            </MenuInnerWithSub>
          )}

          {/* Modules */}
          <MenuInnerWithSub
            title='Modules'
            to='/modules'
            fontIcon='bi-bounding-box'
            hasArrow={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {HasPermission('module', 'create') && (
              <MenuItem to='/app/addmodules' title='Add New Module' hasBullet={true} />
            )}

            <MenuItem to='/app/modules' title='View All Modules' hasBullet={true} />
          </MenuInnerWithSub>

          {/* Roles */}
          {(HasPermission('role', 'create') || HasPermission('role', 'read')) && (
            <MenuInnerWithSub
              title='Roles'
              to='/roles'
              fontIcon='bi-layers'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {HasPermission('role', 'create') && (
                <MenuItem to='/app/roles/add' title='Add New Role' hasBullet={true} />
              )}

              {HasPermission('role', 'read') && (
                <MenuItem to='/app/roles/all' title='View All Roles' hasBullet={true} />
              )}
            </MenuInnerWithSub>
          )}

          {/* Profiles */}
          {(HasPermission('profile', 'create') || HasPermission('profile', 'read')) && (
            <MenuInnerWithSub
              title='Profiles'
              to='/profiles'
              fontIcon='bi-person-bounding-box'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {HasPermission('profile', 'create') && (
                <MenuItem to='/app/profiles/add' title='Add New Profile' hasBullet={true} />
              )}

              {HasPermission('profile', 'read') && (
                <MenuItem to='/app/profiles/all' title='View All Profiles' hasBullet={true} />
              )}
            </MenuInnerWithSub>
          )}

          {/* Subscriptions */}
          {(HasPermission('subscription', 'create') || HasPermission('subscription', 'read')) && (
            <MenuInnerWithSub
              title='Subscriptions'
              to='/subscriptions'
              fontIcon='bi-subtract'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {(HasPermission('subscription', 'create') || currentUser?.is_pay_by_user) && (
                <MenuItem
                  to='/app/subscriptions/add'
                  title='Add New Subscription'
                  hasBullet={true}
                />
              )}

              {(HasPermission('subscription', 'read') || currentUser?.is_pay_by_user) && (
                <MenuItem
                  to='/app/subscriptions/all'
                  title='View All Subscriptions'
                  hasBullet={true}
                />
              )}
            </MenuInnerWithSub>
          )}

          {/* Users */}
          {(HasPermission('user', 'create') || HasPermission('invite_link', 'create')) && (
            <MenuInnerWithSub
              title='Users'
              to='/users'
              fontIcon='bi-people-fill'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {HasPermission('user', 'create') && (
                <MenuItem to='/app/users/inviteusers' title='Invite User' hasBullet={true} />
              )}

              {HasPermission('user', 'create') && (
                <MenuItem to='/app/users/uploadusers' title='Upload Users' hasBullet={true} />
              )}

              {HasPermission('invite_link', 'create') && (
                <MenuItem
                  to='/app/users/invitelinks/add'
                  title='Create Invitation Link'
                  hasBullet={true}
                />
              )}
            </MenuInnerWithSub>
          )}
        </MenuInnerWithSub>
      )}
    </>
  )
}
